/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Tournament,
  UserPlayer,
  UserTeams,
} from '../models/index';
import {
    TournamentFromJSON,
    TournamentToJSON,
    UserPlayerFromJSON,
    UserPlayerToJSON,
    UserTeamsFromJSON,
    UserTeamsToJSON,
} from '../models/index';

export interface GetUserPlayersRequest {
    email: string;
}

export interface GetUserTeamsRequest {
    email: string;
}

export interface GetUserTournamentsRequest {
    email: string;
}

/**
 * UserApi - interface
 * 
 * @export
 * @interface UserApiInterface
 */
export interface UserApiInterface {
    /**
     * 
     * @summary Get all players created by user (across all teams)
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    getUserPlayersRaw(requestParameters: GetUserPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserPlayer>>>;

    /**
     * Get all players created by user (across all teams)
     */
    getUserPlayers(requestParameters: GetUserPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserPlayer>>;

    /**
     * 
     * @summary Get teams for user by email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    getUserTeamsRaw(requestParameters: GetUserTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserTeams>>>;

    /**
     * Get teams for user by email
     */
    getUserTeams(requestParameters: GetUserTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserTeams>>;

    /**
     * 
     * @summary Get tournaments for user by email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    getUserTournamentsRaw(requestParameters: GetUserTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Tournament>>>;

    /**
     * Get tournaments for user by email
     */
    getUserTournaments(requestParameters: GetUserTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Tournament>>;

}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI implements UserApiInterface {

    /**
     * Get all players created by user (across all teams)
     */
    async getUserPlayersRaw(requestParameters: GetUserPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserPlayer>>> {
        if (requestParameters.email === null || requestParameters.email === undefined) {
            throw new runtime.RequiredError('email','Required parameter requestParameters.email was null or undefined when calling getUserPlayers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{email}/players`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters.email))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserPlayerFromJSON));
    }

    /**
     * Get all players created by user (across all teams)
     */
    async getUserPlayers(requestParameters: GetUserPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserPlayer>> {
        const response = await this.getUserPlayersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get teams for user by email
     */
    async getUserTeamsRaw(requestParameters: GetUserTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserTeams>>> {
        if (requestParameters.email === null || requestParameters.email === undefined) {
            throw new runtime.RequiredError('email','Required parameter requestParameters.email was null or undefined when calling getUserTeams.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{email}/teams`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters.email))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserTeamsFromJSON));
    }

    /**
     * Get teams for user by email
     */
    async getUserTeams(requestParameters: GetUserTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserTeams>> {
        const response = await this.getUserTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tournaments for user by email
     */
    async getUserTournamentsRaw(requestParameters: GetUserTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Tournament>>> {
        if (requestParameters.email === null || requestParameters.email === undefined) {
            throw new runtime.RequiredError('email','Required parameter requestParameters.email was null or undefined when calling getUserTournaments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{email}/tournaments`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters.email))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TournamentFromJSON));
    }

    /**
     * Get tournaments for user by email
     */
    async getUserTournaments(requestParameters: GetUserTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Tournament>> {
        const response = await this.getUserTournamentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
